<!-- Header -->
<div mat-dialog-title>
    <span translate>Recipients</span>
</div>

<!-- Body -->
<mat-dialog-content style="width: 60vw; padding-top: 0 !important;">
    <mat-table [dataSource]="angularMatData" multiTemplateDataRows style="width: 100%" #sort="matSort" matSort
        matSortDisableClear matSortActive="name" matSortDirection="asc" aria-label="Recipients Table" tabindex="0">
        <!-- Name Column -->
        <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:250px; max-width:250px;">
                <span translate>Name</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let recipient" style="min-width:250px; max-width:250px;">
                {{recipient.name}}
            </mat-cell>
        </ng-container>

        <!-- Type Column -->
        <ng-container matColumnDef="type">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:100px; max-width:100px;">
                <span translate>Type</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let recipient" style="min-width:100px; max-width:100px;">
                {{recipient.type}}
            </mat-cell>
        </ng-container>

        <!-- Email Column -->
        <ng-container matColumnDef="email">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
                <span translate>Email</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let recipient">{{recipient.email}}</mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;" style="width:780px;" tabindex="0">
        </mat-row>
    </mat-table>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions style="position: sticky">
    <div class="flex-footer-left">
        <tyl-checkbox [disabled]="true" [checked]="includeTeachers">
            <span>Send email to Class Teachers / Co-Teachers</span>
        </tyl-checkbox>
    </div>
    <div class="flex-footer-left" *ngIf="v10">
        <tyl-checkbox [disabled]="true" [checked]="includeTeamStaffMembers">
            <span>Send email to Team Staff Members</span>
        </tyl-checkbox>
    </div>
    <div class="footerRight">
        <tyl-button label="Close" image="Cancel.png" (clickEvent)="closeClick()"></tyl-button>
    </div>
</mat-dialog-actions>